import {
  login,
  logout,
  getUserInfo,
  getMessage,
  getContentByMsgId,
  hasRead,
  removeReaded,
  restoreTrash,
  getUnreadCount,
  getInitCaptcha,
  getInitShortMessage,
  register
} from '@/api/user'
import { setToken, getToken, setUserToken, setOpenToken } from '@/libs/util'
import {resetRouter} from '@/router'
export default {
  state: {
    userId: '',
    avatarImgPath: '',
    token: getToken(),
    access: '',
    hasGetInfo: false,
    unreadCount: 1,
    messageUnreadCount: 0,
    messageReadedCount: 0,
    messageTrashCount: 0,
    messageContentStore: {},
    loading: false,
    loginLoading: false,
    registerLoading: false
  },
  mutations: {
    setAvatar (state, avatarPath) {
      state.avatarImgPath = avatarPath
    },
    setUserId (state, id) {
      state.userId = id
    },
    setAccess (state, access) {
      state.access = access
    },
    setToken (state, token) {
      state.token = token
      setToken(token)
    },
    setHasGetInfo (state, status) {
      state.hasGetInfo = status
    },
    setMessageCount (state, count) {
      state.unreadCount = count
    },
    setMessageUnreadCount (state, list) {
      state.messageUnreadCount = list
    },
    setMessageReadedCount (state, list) {
      state.messageReadedCount = list
    },
    setMessageTrashCount (state, list) {
      state.messageTrashCount = list
    },
    updateMessageContentStore (state, { msg_id, content }) {
      state.messageContentStore[msg_id] = content
    },
    moveMsg (state, { from, to, msg_id }) {
      const index = state[from].findIndex(_ => _.msg_id === msg_id)
      const msgItem = state[from].splice(index, 1)[0]
      msgItem.loading = false
      state[to].unshift(msgItem)
    },
    setLoading (state, loading) {
      state.loading = loading
    },
    setLoginLoading (state, loading) {
      state.loginLoading = loading
    },
    setRegisterLoading (state, loading) {
      state.registerLoading = loading
    }
  },
  getters: {
    messageUnreadCount: state => state.messageUnreadCount,
    messageReadedCount: state => state.messageReadedCount,
    messageTrashCount: state => state.messageTrashCount,
    getUserId: state => state.userId,
    loginLoading: state => state.loginLoading,
    registerLoading: state => state.registerLoading
  },
  actions: {
    // 登录
    handleLogin ({ commit }, { userName, password, captchaId, verify }) {
      userName = userName.trim()
      commit('setLoginLoading', true)
      return new Promise((resolve, reject) => {
        login({
          userName,
          password,
          captchaId,
          verify
        }).then(res => {
          commit('setLoginLoading', false)
          resolve(res)
        }).catch(err => {
          commit('setLoginLoading', false)
          reject(err)
        })
      })
    },
    // 退出登录
    handleLogOut ({ state, commit }) {
      return new Promise((resolve, reject) => {
        logout().then((res) => {
          commit('setToken', '')
          setUserToken('')
          setOpenToken('')
          commit('setAccess', '')
          commit('setHasGetInfo', false)
          commit('setMenuRspList', [])
          resetRouter()
          resolve(res)
        }).catch(err => {
          reject(err)
        })
        // 如果你的退出登录无需请求接口，则可以直接使用下面三行代码而无需使用logout调用接口
        // commit('setToken', '')
        // commit('setAccess', [])
        // resolve()
      })
    },
    // 获取用户相关信息
    getUserInfo ({ state, commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo(state.token).then(res => {
          const data = res.data.result
          let token = ''
          if (data) {
            commit('setAvatar', data.images)
            commit('setUserId', data.id)
            commit('setAccess', data.username)
            commit('setHasGetInfo', true)
            if (data.username !== undefined) {
              token = data.username
            }
          }
          commit('setLoginLoading', false)
          commit('setToken', token)
          resolve(data)
        }).catch(err => {
          commit('setLoginLoading', false)
          reject(err)
        })
      })
    },
    // 此方法用来获取未读消息条数，接口只返回数值，不返回消息列表
    getUnreadMessageCount ({ state, commit }) {
      return new Promise((resolve, reject) => {
        getUnreadCount().then(res => {
          const result = res.data.result
          if (result) {
            const {unreadCount, readCount, trashCount} = result
            commit('setMessageUnreadCount', unreadCount)
            commit('setMessageReadedCount', readCount)
            commit('setMessageTrashCount', trashCount)
          }
          resolve()
        }).catch(err => {
          reject(err)
        })
      })
    },
    // 获取消息列表，其中包含未读、已读、回收站三个列表
    /* getMessageList ({ state, commit }) {
      return new Promise((resolve, reject) => {
        getMessage().then(res => {
          const { unread, readed, trash } = res.data
          // commit('setMessageUnreadCount', unread.sort((a, b) => new Date(b.create_time) - new Date(a.create_time)))
          // commit('setMessageReadedCount', readed.map(_ => {_.loading = false return _ }).sort((a, b) => new Date(b.create_time) - new Date(a.create_time)))
          // commit('setMessageTrashCount', trash.map(_ => {
          //  _.loading = false
          //  return _
          // }).sort((a, b) => new Date(b.create_time) - new Date(a.create_time)))
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }, */
    // 根据当前点击的消息的id获取内容
    getContentByMsgId ({ state, commit }, { msg_id }) {
      return new Promise((resolve, reject) => {
        let contentItem = state.messageContentStore[msg_id]
        if (contentItem) {
          resolve(contentItem)
        } else {
          getContentByMsgId(msg_id).then(res => {
            const content = res.data
            commit('updateMessageContentStore', { msg_id, content })
            resolve(content)
          })
        }
      })
    },
    // 把一个未读消息标记为已读
    hasRead ({ state, commit }, { msg_id }) {
      return new Promise((resolve, reject) => {
        hasRead(msg_id).then(() => {
          commit('moveMsg', {
            from: 'messageUnreadList',
            to: 'messageReadedList',
            msg_id
          })
          commit('setMessageCount', state.unreadCount - 1)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除一个已读消息到回收站
    removeReaded ({ commit }, { msg_id }) {
      return new Promise((resolve, reject) => {
        removeReaded(msg_id).then(() => {
          commit('moveMsg', {
            from: 'messageReadedList',
            to: 'messageTrashList',
            msg_id
          })
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 还原一个已删除消息到已读消息
    restoreTrash ({ commit }, { msg_id }) {
      return new Promise((resolve, reject) => {
        restoreTrash(msg_id).then(() => {
          commit('moveMsg', {
            from: 'messageTrashList',
            to: 'messageReadedList',
            msg_id
          })
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    getInitCaptcha ({ commit }) {
      return new Promise((resolve, reject) => {
        getInitCaptcha().then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    getInitShortMessage ({ commit }, email) {
      return new Promise((resolve, reject) => {
        getInitShortMessage(email).then(res => {
          resolve(res)
        }).catch(err => {
          reject(err)
        })
      })
    },
    handleRegister ({ commit }, data) {
      commit('setRegisterLoading', true)
      return new Promise((resolve, reject) => {
        register(data).then(res => {
          commit('setRegisterLoading', false)
          resolve(res)
        }).catch(err => {
          commit('setRegisterLoading', false)
          reject(err)
        })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/module/user.js